const Footer = () => {
  return (
    <footer className="bg-red-600 text-white mt-auto">
      <div className="max-w-6xl mx-auto px-6 py-8">

        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-6 text-center md:text-left">

          {/* Firma */}
          <div>
            <p className="font-semibold text-lg">A.B.S. GmbH</p>
            <p className="text-sm opacity-90">
              Talweg 2G<br />
              85614 Kirchseeon
            </p>
          </div>

          {/* Links */}
          <div className="flex justify-center md:justify-end gap-6 text-sm">
            <a href="imprint" className="hover:underline">Impressum</a>
            <a href="privacy" className="hover:underline">Datenschutz</a>
            <a href="cookiepolicy" className="hover:underline">Cookie Richtlinien</a>
          </div>
        </div>

        <div className="text-center text-xs opacity-80 mt-6">
          ©  A.B.S. GmbH · Alle Rechte vorbehalten
        </div>

      </div>
    </footer>
  );
};

export default Footer;
